function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-100.006 -143.595)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 100.345 151.99)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fffbd0",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  d: "M0 0c.239.543 1.272 2.854 2.345 5.247l5.156-.039-2.592-6.529H.581c-.156.015-.52.094-.672.334C-.258-.724-.134-.305 0 0m30.538-1.321h-5.111l-1.201 6.405 5.475-.041a826.203 826.203 0 001.543-5.258c.039-.151.103-.63-.098-.889-.114-.147-.313-.217-.608-.217m-6.849 6.408l1.203-6.408H14.835l.997 6.467zm-8.389.062l-.997-6.47H5.477l2.589 6.525zm-7.589.584l-5.131.039c1.243 2.774 2.464 5.494 2.487 5.545.021.06.232.608 1.189.614.591.004 2.274.004 3.916.003zM-.5-1.706c.251-.212.66-.366.978-.398.026-.003.052-.007.08-.007l.001.004h.002v-.004h4.233c.022-.02 20.326 0 20.326 0 .043-.03 5.418 0 5.418 0 .686 0 1.05.287 1.235.526.472.612.259 1.485.232 1.581-.33 1.142-3.218 11.086-3.647 11.954-.301.612-.937.775-1.264.775l-2.539-.028a.394.394 0 01.005-.789h.003l2.535.027c.006-.001.393-.013.551-.334.183-.371.998-3.02 1.896-6.03l-5.419.04-.912 4.868a.265.265 0 01-.308.211.265.265 0 01-.211-.307l.895-4.768-7.677.057.738 4.788a.265.265 0 01-.22.301.267.267 0 01-.3-.221l-.75-4.863-7.106.052 2.463 6.205h1.616l1.611-.008a.394.394 0 01-.004.789h-.007v.006s-6.419.008-7.704 0c-1.553-.009-1.906-1.079-1.921-1.123C4.301 11.54-.189 1.531-.722.318c-.485-1.103-.147-1.71.222-2.024"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 107.568 145.953)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fffbd0",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  d: "M0 0c-.876-.875-.815-2.357-.815-2.357s1.48-.061 2.356.816c.876.875.815 2.355.815 2.355S.874.875 0 0"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 107.568 144.905)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fffbd0",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  d: "M0 0c-.876-.876-.815-2.357-.815-2.357s1.48-.061 2.356.815c.876.876.815 2.356.815 2.356S.874.875 0 0"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 107.568 147.001)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fffbd0",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  d: "M0 0c-.876-.876-.815-2.357-.815-2.357s1.48-.061 2.356.815c.876.875.815 2.356.815 2.356S.874.875 0 0"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 106.75 145.969)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fffbd0",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  d: "M0 0c.876-.876.815-2.356.815-2.356s-1.48-.061-2.357.815c-.875.874-.814 2.356-.814 2.356S-.875.876 0 0"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 106.75 144.92)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fffbd0",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  d: "M0 0c.876-.876.815-2.356.815-2.356s-1.48-.061-2.357.815c-.875.874-.814 2.355-.814 2.355S-.875.875 0 0"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 106.75 147.017)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fffbd0",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  d: "M0 0c.876-.876.815-2.357.815-2.357s-1.48-.061-2.357.815c-.875.876-.814 2.356-.814 2.356S-.875.875 0 0"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 106.774 144.386)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fffbd0",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  d: "M0 0c0 1.237 1.09 2.242 1.09 2.242S2.181 1.237 2.18 0c.001-1.237-1.09-2.242-1.09-2.242S.001-1.237 0 0"
})));

var SvgFieldCb = function SvgFieldCb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44.052,
    height: 34.56,
    viewBox: "0 0 11.655 9.144",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFieldCb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/field_cb.96e4cbde.svg";
export { ForwardRef as ReactComponent };